// src/pages/About.js
import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  IconButton,
  Stack,
} from '@mui/material';
import {
  Email as EmailIcon,
  School as SchoolIcon,
  Work as WorkIcon,
  Star as StarIcon,
  BusinessCenter as BusinessCenterIcon,
  Facebook as FacebookIcon,
  X as XIcon,
  YouTube as YouTubeIcon,
  LinkedIn as LinkedInIcon,
  Instagram as InstagramIcon,
} from '@mui/icons-material';

function About() {
  return (
    <Container maxWidth="md">
      <Box sx={{ my: 8 }}>
        {/* Header Section with Avatar */}
        <Stack direction="column" alignItems="center" spacing={2}>
          <Avatar
            alt="Keegan Hutchins"
            sx={{
              width: 250,
              height: 250,
              mb: 2,
            }}
          >
            <img
              src="/resources/about/self_new.png"
              alt="Keegan Hutchins"
              style={{
                width: '155%',
                height: '105%',
                objectFit: 'contain', // Ensures the whole image is visible
              }}
            />
          </Avatar>

          <Typography
            variant="h3"
            component="h1"
            gutterBottom
            sx={{ fontWeight: 'bold', textAlign: 'center' }}
          >
            Keegan Hutchins
          </Typography>
          <Typography
            variant="h5"
            component="h2"
            gutterBottom
            sx={{ textAlign: 'center', color: 'text.secondary' }}
          >
            Software Developer | Designer | Computer Scientist
          </Typography>
        </Stack>

        {/* Social Media Links */}
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <IconButton
            component="a"
            href="https://www.instagram.com/keegan_hutchins/"
            target="_blank"
            aria-label="Instagram"
          >
            <InstagramIcon />
          </IconButton>
          <IconButton
            component="a"
            href="https://www.facebook.com/keegan.hutchins.94"
            target="_blank"
            aria-label="Facebook"
          >
            <FacebookIcon />
          </IconButton>
          <IconButton
            component="a"
            href="https://x.com/khutchhh"
            target="_blank"
            aria-label="X"
          >
            <XIcon />
          </IconButton>
          <IconButton
            component="a"
            href="https://www.youtube.com/@audiohutch"
            target="_blank"
            aria-label="YouTube"
          >
            <YouTubeIcon />
          </IconButton>
          <IconButton
            component="a"
            href="https://www.linkedin.com/in/keegan-hutchins-07a969160/"
            target="_blank"
            aria-label="LinkedIn"
          >
            <LinkedInIcon />
          </IconButton>
        </Box>

        {/* Contact Info */}
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography
            variant="body1"
            component="p"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <EmailIcon sx={{ fontSize: '1rem', color: 'primary.main' }} />
            neehaw.service@gmail.com
          </Typography>
        </Box>

        {/* Education and Achievements */}
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ p: 3 }}>
              <Typography variant="h6" component="h3" gutterBottom>
                Education & Achievements
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <SchoolIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Liberal Arts Degree"
                    secondary="Completed at age 18"
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <SchoolIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Computer Science Degree"
                    secondary="Graduated at age 20 with a Minor in Business Administration"
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <StarIcon />
                  </ListItemIcon>
                  <ListItemText primary="Maintained 3.98 GPA throughout college while working full time" />
                </ListItem>
              </List>
            </Paper>
          </Grid>

          {/* Work Experience */}
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ p: 3 }}>
              <Typography variant="h6" component="h3" gutterBottom>
                Work Experience
              </Typography>
              <List>
                <ListItem>
                  <ListItemIcon>
                    <WorkIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Oracle - Full Stack Engineer II"
                    secondary="Aug 2023 - Current"
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <WorkIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Collective Data - Application Developer III"
                    secondary="Oct 2019 - Apr 2023"
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <WorkIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Kirkwood Community College - Computer Lab Assistant"
                    secondary="Aug 2018 - May 2019"
                  />
                </ListItem>
                <ListItem>
                  <ListItemIcon>
                    <WorkIcon />
                  </ListItemIcon>
                  <ListItemText primary="UPS - Package Handler" />
                </ListItem>
              </List>
            </Paper>
          </Grid>
        </Grid>

        {/* Skills & Highlights */}
        <Box sx={{ my: 6 }}>
          <Typography variant="h6" component="h3" gutterBottom>
            Skills & Highlights
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <BusinessCenterIcon />
              </ListItemIcon>
              <ListItemText primary="50,000+ views on YouTube" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <BusinessCenterIcon />
              </ListItemIcon>
              <ListItemText primary="3,000+ mobile app downloads" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <StarIcon />
              </ListItemIcon>
              <ListItemText primary="Honor Roll (4x) and Dean's List (3x)" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <StarIcon />
              </ListItemIcon>
              <ListItemText primary="Experience with remote computer troubleshooting" />
            </ListItem>
          </List>
        </Box>
      </Box>
    </Container>
  );
}

export default About;
